<template>
    <div class="mt-2">
      <!-- <data-view-sidebar :isSidebarActive="addNewDataSidebarEditDataClientEXT" @closeSidebar="toggleDataSidebarEditDataClientEXT" :data="sidebarDataEditDataClientEXT" v-on:closeSidebar="updateListClientsEXT" /> -->
      <!-- <data-view-sidebar-change-password :isSidebarActive="addNewDataSidebarChangePasswordClientPDN" @closeSidebar="toggleDataSidebarChangePasswordClientPDN" :data="sidebarDataChangePasswordClientPDN" v-on:closeSidebarSuccess="updateListClientsEXT" /> -->
      <!-- <data-view-sidebar-change-plan :isSidebarActive="addNewDataSidebarChangePlanClient" @closeSidebar="toggleDataSidebarChangePlanClient" :data="sidebarDataChangePlanClient" v-on:closeSidebar="updateListClientsEXT" /> -->
      <data-view-sidebar-change-inmigration :isSidebarActive="addNewDataSidebarChangeInmigration" @closeSidebar="toggleDataSidebarChangeInmigration" :data="sidebarDataChangeInmigration" v-on:closeSidebarSuccess="updateListClientsEXT"/>
      <!-- <data-view-sidebar-remove-inmigration :isSidebarActive="addNewDataSidebarRemoveInmigration" @closeSidebar="toggleDataSidebarRemoveInmigration" :data="sidebarDataRemoveInmigration" v-on:closeSidebarSuccess="updateListClientsEXT"/> -->
      <data-view-sidebar-change-advisor :isSidebarActive="addNewDataSidebarChangeAdvisor" @closeSidebar="toggleDataSidebarChangeAdvisor" :data="sidebarDataChangeAdvisor" v-on:closeSidebarSuccess="updateListClientsEXT"/>
      
      <vs-dropdown class="z-custom" vs-trigger-click>
        <a class="flex items-center" href.prevent>
          <i class="material-icons"> more_vert </i>
        </a>
        <vs-dropdown-menu class="z-custom">
          <!-- <vs-dropdown-item @click="resendEmailVerification(params.data)" v-if="params.data.verified_email_user == 0">
            <feather-icon icon="MailIcon" svgClasses="h-4 w-4 mr-2 text-warning hover:text-primary cursor-pointer"/> 
            <span>Reenviar correo verificación</span> 
          </vs-dropdown-item> -->
          <vs-dropdown-item @click="goToPerfilInternoCliente(params.data)">
            <feather-icon icon="UserIcon" svgClasses="h-4 w-4 mr-2 hover:text-primary cursor-pointer"/> 
            <span>Ir al perfil del cliente</span> 
          </vs-dropdown-item>
          <!-- <vs-dropdown-item @click="editDataClient(params.data)">
            <feather-icon icon="Edit3Icon" svgClasses="h-4 w-4 mr-2 hover:text-primary cursor-pointer"/> 
            <span>Editar datos básicos</span> 
          </vs-dropdown-item> -->
          <!-- <vs-dropdown-item @click="changePassword(params.data)">
            <feather-icon icon="KeyIcon" svgClasses="h-4 w-4 mr-2 hover:text-primary cursor-pointer"/> 
            <span>Cambiar password</span> 
          </vs-dropdown-item> -->
          <!-- <vs-dropdown-item @click="changePlanClient(params.data)" disabled>
            <feather-icon icon="BriefcaseIcon" svgClasses="h-4 w-4 mr-2 hover:text-primary cursor-pointer"/> 
            <span>Asignar Plan VideoPortal</span> 
          </vs-dropdown-item> -->
          <vs-dropdown-item @click="changeInmigrationService(params.data)" :disabled="params.data.flag_active_plan_added_service === 1">
            <feather-icon icon="FlagIcon" svgClasses="h-4 w-4 mr-2 hover:text-primary cursor-pointer"/> 
            <span>Asignar Servicio Extranjería</span> 
          </vs-dropdown-item>
          <!-- <vs-dropdown-item @click="removeInmigrationService(params.data)">
            <feather-icon icon="XIcon" svgClasses="h-4 w-4 mr-2 text-danger hover:text-primary cursor-pointer"/> 
            <span>Remover Servicio Extranjería Modo1</span> 
          </vs-dropdown-item> -->
          <vs-dropdown-item @click="activePrompt = true">
            <feather-icon icon="XIcon" svgClasses="h-4 w-4 mr-2 text-danger hover:text-primary cursor-pointer"/> 
            <span>Remover Servicio Extranjería Modo2</span> 
          </vs-dropdown-item>
          <vs-dropdown-item @click="changeAdvisor(params.data)">
            <feather-icon icon="ShieldIcon" svgClasses="h-4 w-4 mr-2 text-danger hover:text-primary cursor-pointer"/> 
            <span>Cambiar Asesor</span> 
          </vs-dropdown-item>
          <vs-dropdown-item @click="sendWelcomeEmailInmigration(params.data)">
            <feather-icon icon="MailIcon" svgClasses="h-4 w-4 mr-2 text-success hover:text-primary cursor-pointer"/> 
            <span>Enviar Email de Bienvenida</span> 
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <vs-prompt
        @cancel="val=''"
        @accept="confirmRemoveInmigration"
        title="Confirmar remoción de servicio extranjería"
        acceptText= "Remover"
        cancelText= "Cancelar"
        :is-valid="validWord"
        :active.sync="activePrompt">
        <div class="con-exemple-prompt">
          <span>¿Está seguro de remover el servicio de extranjería a: <strong>{{params.data.names_client}} {{params.data.surnames_client}}</strong>?</span>
          <p class="mt-3">Escriba "remover extranjería" para continuar</p>
          <vs-input placeholder="Escriba 'remover extranjería'" vs-placeholder="Escriba 'remover extranjería'" v-model="val" class="w-full" />
        </div>
      </vs-prompt>
    </div>
</template>

<script>
// import EditDataClientsEXTViewSidebar from './../EditDataClientsEXTViewSidebar.vue'
// import ChangePasswordClientsPDNViewSidebar from './../ChangePasswordClientsPDNViewSidebar.vue'
// import ChangePlanClientViewSidebar from '../ChangePlanClientViewSidebar.vue'
import ChangeInmigrationViewSidebar from '../ChangeInmigrationViewSidebar.vue'
// import RemoveInmigrationViewSidebar from '../RemoveInmigrationViewSidebar.vue'
import ChangeAdvisorViewSidebar from '../ChangeAdvisorViewSidebar.vue'

export default {
  components: {
    // DataViewSidebar: EditDataClientsEXTViewSidebar,
    // DataViewSidebarChangePassword: ChangePasswordClientsPDNViewSidebar,
    // DataViewSidebarChangePlan: ChangePlanClientViewSidebar,
    DataViewSidebarChangeInmigration: ChangeInmigrationViewSidebar,
    // DataViewSidebarRemoveInmigration: RemoveInmigrationViewSidebar,
    DataViewSidebarChangeAdvisor: ChangeAdvisorViewSidebar
  },
  data () {
    return {
      // Data Sidebar Edit Data Client
      addNewDataSidebarEditDataClientEXT: false,
      sidebarDataEditDataClientEXT: {},
      // Data Sidebar Change Password
      addNewDataSidebarChangePasswordClientPDN: false,
      sidebarDataChangePasswordClientPDN: {},

      // Data Sidebar Change Plan
      addNewDataSidebarChangePlanClient: false,
      sidebarDataChangePlanClient: {},

      // Data Sidebar Inmigration
      addNewDataSidebarChangeInmigration: false,
      sidebarDataChangeInmigration: {},

      // Data Sidebar Remove Inmigration
      addNewDataSidebarRemoveInmigration: false,
      sidebarDataRemoveInmigration: {},

      // Data Sidebar Change Advisor
      addNewDataSidebarChangeAdvisor: false,
      sidebarDataChangeAdvisor: {},

      activePrompt:false,
      val:'',
      id_client: null
    }
  },
  name: 'CellRendererActions',
  computed: {
    validWord () {
      return (this.val.length > 0 && this.val === 'remover extranjería')
    }
  },
  methods: {
    sendWelcomeEmailInmigration (obj) {
      obj.type_of_service = 'Inmigration'
      this.$vs.loading()
      this.$store.dispatch('sendWelcomeEmail', obj)
        .then(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            color:'success',
            title: 'Email enviado',
            text: 'Se ha enviado el email de bienvenida al cliente',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            time: 4000
          })
        })
        .catch((error) => { 
          console.log(error)
          // console.log(error.response)
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Ha ocurrido un error',
            text: `${error.response.data.errors}`,
            iconPack: 'feather',
            icon: 'icon-x-circle',
            color: 'warning',
            time: 6000
          })
        })

    },
    goToPerfilInternoCliente (data) {
      this.$router.push({name: 'admin.cliente', params: {id_client: data.id_client}})
    },
    updateListClientsEXT () {
      this.$vs.loading()
      setTimeout(function () { this.refrescarClientsEXT() }.bind(this), 0)
    },
    refrescarClientsEXT () {
      this.$store.dispatch('fetchClientsInmigration')
        .then(() => { this.$vs.loading.close() })
    },
    resendEmailVerification (data) {
      const obj = {
        email: data.email_user
      }
      this.$vs.loading()
      this.axios.post('/client/resend-email-verification', obj)
        .then(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            color:'success',
            title: 'Email enviado',
            text: 'Se ha reenviado el correo electrónico de verificación',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            time: 4000
          })
        })
        .catch((error) => {
          console.log(error)
          // console.log(error.response)
          this.$vs.loading.close()

          this.$vs.notify({
            title: 'Verificación de email fallido',
            text: `${error.response.data.errors}`,
            iconPack: 'feather',
            icon: 'icon-x-circle',
            color: 'warning',
            time: 6000
          })
        })

    },
    changePassword (data) {
      const obj = {
        id_client: data.id_client
      }
      this.$store.dispatch('fetchClientPerfil', obj)
        .then((response) => {
          const obj2 = response.data.client
          this.sidebarDataChangePasswordClientPDN = obj2
          this.toggleDataSidebarChangePasswordClientPDN(true)
        })
    },
    toggleDataSidebarChangePasswordClientPDN (val = false) {
      this.addNewDataSidebarChangePasswordClientPDN = val
    },
    changeAdvisor (data) {
      const obj = {
        id_client: data.id_client
      }
      if (this.$store.state.employees.length === 0) {
        this.$store.dispatch('fetchEmployees').catch(err => { console.error(err) })
      }
      this.$store.dispatch('fetchClientPerfil', obj)
        .then((response) => {
          const obj2 = response.data.client
          this.sidebarDataChangeAdvisor = obj2
          this.toggleDataSidebarChangeAdvisor(true)
        })
    },
    toggleDataSidebarChangeAdvisor (val = false) {
      this.addNewDataSidebarChangeAdvisor = val
    },
    editDataClient (data) {
      const obj = {
        id_client: data.id_client
      }
      this.$store.dispatch('fetchClientPerfil', obj)
        .then((response) => {
          const obj2 = response.data.client
          this.sidebarDataEditDataClientEXT = obj2
          this.toggleDataSidebarEditDataClientEXT(true)
        })
    },
    toggleDataSidebarEditDataClientEXT (val = false) {
      this.addNewDataSidebarEditDataClientEXT = val
    },
    changePlanClient (data) {
      const obj = {
        id_client: data.id_client
      }
      this.sidebarDataChangePlanClient = data
      this.$store.dispatch('fetchServices')
      this.$store.dispatch('fetchPaymentsForAClient', obj)
        .catch(err => { 
          this.$vs.loading.close()
          console.error(err)
          if (typeof err.response.data.error === 'string') {
            this.$vs.notify({
              title: 'Error',
              text: `${err.response.data.error}`,
              color: 'warning',
              iconPack: 'feather',
              icon:'icon-x-circle',
              time: 6000
            })
          } else {
            const array_errors = Object.entries(err.response.data.error)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          }
        })
      this.toggleDataSidebarChangePlanClient(true)
    },
    toggleDataSidebarChangePlanClient (val = false) {
      this.addNewDataSidebarChangePlanClient = val
    },
    changeInmigrationService (data) {
      const obj = {
        id_client: data.id_client
      }
      this.sidebarDataChangeInmigration = data
      this.$store.dispatch('fetchClientPerfil', obj).catch(error => console.log(error))
      this.$store.dispatch('fetchServices').catch(error => console.log(error))
      this.$store.dispatch('fetchPaymentsForAClient', obj).catch(error => console.log(error))
      this.$store.dispatch('fetchVisaTypes', obj).catch(error => console.log(error))
      this.toggleDataSidebarChangeInmigration(true)
    },
    toggleDataSidebarChangeInmigration (val = false) {
      this.addNewDataSidebarChangeInmigration = val
    },
    removeInmigrationService (data) {
      const obj = {
        id_client: data.id_client
      }
      this.$store.dispatch('fetchClientPerfil', obj).catch(error => console.log(error))
      this.sidebarDataRemoveInmigration = data
      this.toggleDataSidebarRemoveInmigration(true)
    },
    toggleDataSidebarRemoveInmigration (val = false) {
      this.addNewDataSidebarRemoveInmigration = val
    }, 
    confirmRemoveInmigration () {
      const obj = {
        id: this.id_client
      }
      this.$store.dispatch('removeInmigrationService', obj)
        .then(() => {
          this.$vs.notify({
            title: 'Servicio Inmigracion removido',
            text: 'Se ha removido un servicio de inmigración',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check',
            time: 4000
          }) 
        })
        .then(() => {
          this.$store.dispatch('fetchClientsInmigration')
            .catch(err => { 
              console.error(err)
              this.$vs.notify({
                title: 'Error',
                text:  `${err.response.data.error}`,
                color: 'danger',
                iconPack: 'feather',
                icon:'icon-alert-circle',
                time:6000
              })
            })
        })
        .catch(err => { 
          this.$vs.loading.close()
          console.error(err)
          const mensaje_error = err.response.data.error
          if (typeof mensaje_error === 'string') {
            this.$vs.notify({
              title: 'Error',
              text: `${mensaje_error}`,
              color: 'warning',
              iconPack: 'feather',
              icon:'icon-x-circle',
              time: 6000
            })
          } else {
            const array_errors = Object.entries(mensaje_error)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          }
        })
    }

  },
  created () {
    this.id_client = this.params.data.id_client
  }
}
</script>

<style scoped>
.z-custom {
  z-index:999999999!important;
}
</style>